export const popular = [
  'Dubai Sky Diving',
  'Rome City Cards',
  'Paris Cruises & Boat Tours',
  'New York City City Cards',
  'New Orleans Ghost & Vampire Tours',
  'New Orleans Walking Tours',
  'New Orleans City Cards',
  'Rome Museum Tickets',
  'New York City Museum Tickets',
  'New Orleans Museum Tickets',
  'Atlanta Museum Tickets',
  'London Walking Tours',
  'London Cruises & Boat Tours',
  'London City Cards',
  'New York City Hop-on Hop-off Tours',
  'New Orleans Hop-on Hop-off Tours',
  'London Hop-on Hop-off Tours',
  'Barcelona Hop-on Hop-off Tours',
  'Amsterdam Hop-on Hop-off Tours',
  'London Ghost & Vampire Tours',
  'Paris Walking Tours',
  'Berlin Walking Tours',
  'Barcelona Walking Tours',
  'London Museum Tickets',
  'New York City Food & Gourmet Tours',
  'New York City Walking Tours',
  'Rome Food & Gourmet Tours',
  'Paris Food & Gourmet Tours',
  'New York City Cruises & Boat Tours',
  'Barcelona Museum Tickets',
  'Berlin City Cards',
  'Berlin Museum Tickets',
  'Barcelona City Cards',
  'Atlanta City Cards',
  'Amsterdam Museum Tickets',
  'Amsterdam City Cards',
];
